// extracted by mini-css-extract-plugin
export default {"job":"vP_gVJZ8","author":"ktUZS2U7","body":"QRlTdwoc"};